module.exports = __webpack_public_path__ + "img/getboarded-logo.d9e1d832.svg";